/**
 * @file: useMemberAccount.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCurrentUserDangerously } from '@euler/app/flows/auth/context';
import { useCachedQuery } from '@euler/functions/useCachedQuery';
import { useServiceFactory } from '@euler/services/factory';

export const useMemberAccount = () => {
  const { storeService } = useServiceFactory();
  const currentUser = useCurrentUserDangerously();
  const memberId = currentUser.user.memberId;
  return useCachedQuery(`accounts/${memberId}.json`, 30, async () => {
    return await storeService.getMemberAccountInfo(memberId);
  });
};
